import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { store } from './redux/store';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { checkAuth } from './redux/authSlice';
import { MessageProvider, useMessage } from './contexts/MessageContext';
import { messageManager } from './utils/messageManager';

const MessageInitializer = ({ children }) => {
  const messageApi = useMessage();

  useEffect(() => {
    // Инициализируем messageManager с API
    messageManager.setMessageApi(messageApi);
  }, [messageApi]);

  return children;
};

const AppInitializer = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);
  return <RouterProvider router={router} />;
};

const App = () => (
  <Provider store={store}>
    <MessageProvider>
      <MessageInitializer>
        <AppInitializer />
      </MessageInitializer>
    </MessageProvider>
  </Provider>
);

export default App;
